'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _passthroughProps = require('../utils/propTypes/passthroughProps');

var _passthroughProps2 = _interopRequireDefault(_passthroughProps);

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var _omit = require('../utils/underscore/omit');

var _omit2 = _interopRequireDefault(_omit);

var _UIButton = require('./UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Button = (0, _styledComponents2.default)(_UIButton2.default).withConfig({
  displayName: 'UIIconButton__Button'
})(['&&&{padding-left:0;padding-right:0;text-align:center;text-overflow:clip;}&&{font-size:', ';width:', ';}'], function (_ref) {
  var size = _ref.size;

  if (size === 'xs') return '12px';
  if (size === 'sm') return '16px';
  return '18px';
}, function (_ref2) {
  var size = _ref2.size,
      use = _ref2.use;

  if (use === 'unstyled' || use.includes('link')) return 'auto';
  if (size === 'xs') return '26px';
  if (size === 'sm') return '32px';
  return '40px';
});

var UIIconButton = function UIIconButton(props) {
  var autoPlacement = props.autoPlacement,
      className = props.className,
      placement = props.placement,
      shape = props.shape,
      size = props.size,
      tooltip = props.tooltip,
      tooltipProps = props.tooltipProps,
      TooltipContent = props.TooltipContent,
      rest = _objectWithoutProperties(props, ['autoPlacement', 'className', 'placement', 'shape', 'size', 'tooltip', 'tooltipProps', 'TooltipContent']);

  return _react2.default.createElement(
    _UITooltip2.default,
    _extends({
      autoPlacement: autoPlacement,
      Content: TooltipContent,
      title: tooltip,
      placement: placement
    }, tooltipProps),
    _react2.default.createElement(Button, _extends({}, rest, {
      className: (0, _classnames2.default)('private-button--icon-only', { 'private-button--circle': shape === 'circle' }, className),
      responsive: false,
      size: (0, _tshirtSize.toShorthandSize)(size)
    }))
  );
};

UIIconButton.propTypes = _extends({}, (0, _omit2.default)(_UIButton2.default.propTypes, ['block', 'responsive']), {
  autoPlacement: _UITooltip2.default.propTypes.autoPlacement,
  children: _propTypes2.default.node,
  iconClassName: _propTypes2.default.string,
  placement: _UITooltip2.default.propTypes.placement,
  shape: _propTypes2.default.oneOf(['square', 'circle']),
  tooltip: _UITooltip2.default.propTypes.title,
  tooltipProps: (0, _passthroughProps2.default)(_UITooltip2.default),
  TooltipContent: _UITooltip2.default.propTypes.Content
});

UIIconButton.defaultProps = _extends({}, _UIButton2.default.defaultProps, {
  block: false,
  placement: _UITooltip2.default.defaultProps.placement,
  shape: 'square',
  use: 'tertiary-light'
});

UIIconButton.displayName = 'UIIconButton';

exports.default = UIIconButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/button/UIIconButton.js
// module id = 518
// module chunks = 177